<template>
  <div class="desktop-space-saver" v-if="showBar">
    <div class="d-flex flex-row f14-l17 df16-l20 floatingbar text-center margin-lr--20 dmargin-lr-0 desktop-sticky pointer">
      <div class="flex-grow-1 text-white" v-for="(field,idx) in content.fields" :key="idx" :class="`field-`+idx" @click="searchPopup">
        <SvgImage v-if="field.icon" :src="field.icon" style="margin-left: 5px;" />
        {{field.text}}
      </div>
      <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup">
        <SearchPopupComponent @close="closePopup" />
      </PopupComponent>
    </div>
  </div>
</template>
<script>
// import {fetch3} from '@/modules/configuration.js'
import SvgImage from "@/components/generic/SvgImage";
import PopupComponent from '@/components/PopupComponent.vue';
import SearchPopupComponent from '@/components/popup/SearchPopupComponent.vue';
export default {
  components: {
    SvgImage,
    PopupComponent,
    SearchPopupComponent
  },
  props: {
    content: Object,
    scrollY: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      showPopup: false,
      showBar: true,
      // liveContent: {}
    }
  },
  mounted() {
    this.liveContent = this.content;
    if (this.scrollY > 0) {
      window.addEventListener('scroll', this.handleScroll);
      this.showBar = false;
    }
    // this.emitter.on("city-selected", () => {
    //   this.getData(this.updateUrl);
    // });
  },
  unmounted() {
    if (this.scrollY > 0) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    this.emitter.off("city-selected");
  },
  methods: {
    handleScroll() {
      // console.log(evt);
      this.showBar = window.pageYOffset >= this.scrollY;
    },
    searchPopup() {
      this.showPopup = true;
    },
    closePopup(refresh, newurl) {
      this.showPopup = false;
      if (refresh) {
        if (newurl) {
          this.$router.push(newurl);
          return;
        }
        this.$router.go(0);
      }
    },
    // async getData(url) {
    //   const data = await fetch3(this, {
    //     url: url,
    //     method: "post",
    //     addQueryString: true
    //   });
    //   this.liveContent = data.floating_bar.form;
    // }

  }
}
</script>
<style scoped>
.floatingbar {
  height: 40px;
  background-color: #ef3d49;
}

.floatingbar div {
  line-height: 40px !important;
}

.floatingbar .field-1 {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

@media (min-width: 1200px) {
  .desktop-sticky {
    position: fixed;
    top: 61px;
    left: 0;
    right: 0;
    z-index: 1500;
  }

  .desktop-space-saver {
    height: 40px;
  }
}
</style>